@if (isOpen()) {
  <div class="confirmation-dialog" role="presentation">
    <button class="confirmation-dialog__backdrop" type="button" aria-label="Close dialog" (click)="cancelled.emit()"></button>

    <section
      class="confirmation-dialog__panel"
      role="dialog"
      aria-modal="true"
      [attr.aria-label]="title()"
    >
      <div class="confirmation-dialog__icon" aria-hidden="true">
        <span class="fa-solid fa-triangle-exclamation"></span>
      </div>

      <div class="confirmation-dialog__content">
        <h2 class="confirmation-dialog__title">{{ title() }}</h2>
        <p class="confirmation-dialog__message">{{ message() }}</p>
      </div>

      <div class="confirmation-dialog__actions">
        @if (showCancel()) {
          <button class="secondary-button" type="button" (click)="cancelled.emit()">
            {{ cancelLabel() }}
          </button>
        }
        <button class="primary-button" type="button" [disabled]="confirmDisabled()" (click)="confirmed.emit()">
          {{ confirmLabel() }}
        </button>
      </div>
    </section>
  </div>
}
